import { render } from "./comp-room.vue?vue&type=template&id=1dba175c&scoped=true"
import script from "./comp-room.vue?vue&type=script&lang=js"
export * from "./comp-room.vue?vue&type=script&lang=js"

import "./comp-room.vue?vue&type=style&index=0&id=1dba175c&scoped=true&lang=css"

import exportComponent from "D:\\work\\kaifengzimaoqu\\wt_front\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1dba175c"]])

export default __exports__